// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Wallet  (types + API for pages/Wallet.tsx, the checkout and the cancel flow)
// The signed-in customer's ZenFresh wallet: a CREDITS LEDGER (GET /api/me/wallet → backend `wallets/{uid}` + `entries`).
// Credits come only from ZenFresh — a refund the customer chose to receive as credit, the wallet part of a cancelled
// order, or credit staff grant — and are spent at checkout. There is no top-up and no withdrawal. Amounts are whole rupees.
// ─────────────────────────────────────────────────────────────────────────────
import { apiAuthed } from "./api";

export interface WalletEntry {
  id: string;
  kind: "credit" | "debit";
  amount: number;
  balanceAfter: number;
  reason: "grant" | "order_cancelled" | "order_payment" | "referral_reward" | "claim_credit";
  note: string;
  orderRef: string | null;
  createdAt: string;
}

export interface Wallet {
  balance: number;
  /** Newest first. */
  entries: WalletEntry[];
}

export const fetchWallet = () => apiAuthed<Wallet>("GET", "/me/wallet");

/** A short title for a ledger row. */
export const REASON_LABEL: Record<WalletEntry["reason"], string> = {
  grant: "Credit from ZenFresh",
  order_cancelled: "Refund to wallet",
  order_payment: "Used on an order",
  referral_reward: "Referral reward",
  claim_credit: "Problem credit",
};
